var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
  'section-statistics__tab section-statistics__tab--unsubscribes',
  'section-statistics__row',
  {'section-statistics__row--long-table-mode': _vm.longTablePart}
]},[(_vm.commType === 'email')?_c('BasicTable',{attrs:{"isLoading":_vm.$store.state.stat.loadings.unsubscribe,"isError":_vm.$store.state.stat.errors.unsubscribe,"value":_vm.formedInfo}}):_vm._e(),_c('div',{staticClass:"section-statistics__column"},[_c('BarPart'),_c('TablePart')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }